// Trial Balance Getters

export const getTrialBalanceList = state => {
  return state.trialBalanceList
}
